/** Tabs and sort keys of the employee list; the URL list state accepts only these. */
export type TabId = 'all' | 'Active' | 'Inactive' | 'Terminated';
export type SortId = 'name' | 'utilization' | 'status';
export const TAB_IDS: readonly TabId[] = ['all', 'Active', 'Inactive', 'Terminated'];
export const SORT_IDS: readonly SortId[] = ['name', 'utilization', 'status'];
